AFRAME.registerComponent("runtime-settings", {
  schema: {
    configManager: {
      default: {},
      parse: v => (typeof v === "object" ? v : JSON.parse(v)),
      stringify: JSON.stringify
    },
  },

});